import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import styles from "./Admin.module.css";

import { useClient } from "../../hooks/useClient.js";

import ReactLoading from "react-loading";
import ErrorMessage from "../../components/shared/ErrorMessage.js";
import Header from "../../components/header/header.js";
import SideMenu from "../../components/sideMenu/sideMenu.js";

function Admin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { clientData, clientIsLoading, clientError } = useClient();

  // The admin login page should be a clean screen — no side menu, no logout.
  const isLoginPage = location.pathname.endsWith("/login");

  if (clientIsLoading) return (
      <div className="centering-container">
        <ReactLoading type="spin" color="#6c757d" height={60} width={60} />
      </div>
    )
  if (clientError) return (
    <ErrorMessage 
      title="Connection Issue"
      error="There seems to be an issue. Please try again later."
    />
  );

  return (
    <div className={styles.layout} >
      <div className={`${styles.head} ${isLoginPage ? "" : styles.withMenu}`}>
      {!isLoginPage && <SideMenu client={clientData} />}
      <Header
          name={clientData.companyName}
          websiteUrl={clientData.website}
          logoUrl={clientData.logo}
          doSomething={isLoginPage ? null : () => {
            Cookies.remove(`${clientData.id}_token`);
            navigate(`/${clientData.id}/admin/login`);
          }}
        />
      </div>
      <div className={styles.main}>
        
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Admin;
